<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns(slot='dropdown')
      h3.font--r-m {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-table-menu-issues',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowCompradorIssue',
      'isShowFechaRegistroIssue',
      'isShowEstadoIssue',
      'isShowVendedorIssue',
      'isShowServicioIssue',
      'isShowAsuntoIssue',
      'isShowPrioridadIssue',
      'isShowTipoIssue',
      'optionsFilterService'
    ])
  },

  methods: {
    ...mapActions([
      'isShowCompradorIssueState',
      'isShowFechaRegistroIssueState',
      'isShowEstadoIssueState',
      'isShowVendedorIssueState',
      'isShowServicioIssueState',
      'isShowAsuntoIssueState',
      'isShowPrioridadIssueState',
      'isShowTipoIssueState'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'comprador':
          isShow = !this.isShowCompradorIssue
          this.isShowCompradorIssueState(isShow)
          break
        case 'vendedor':
          isShow = !this.isShowVendedorIssue
          this.isShowVendedorIssueState(isShow)
          break
        case 'fecha-registro':
          isShow = !this.isShowFechaRegistroIssue
          this.isShowFechaRegistroIssueState(isShow)
          break
        case 'estado':
          isShow = !this.isShowEstadoIssue
          this.isShowEstadoIssueState(isShow)
          break
        case 'servicio':
          isShow = !this.isShowServicioIssue
          this.isShowServicioIssueState(isShow)
          break
        case 'asunto':
          isShow = !this.isShowAsuntoIssue
          this.isShowAsuntoIssueState(isShow)
          break
        case 'prioridad':
          isShow = !this.isShowPrioridadIssue
          this.isShowPrioridadIssueState(isShow)
          break
        case 'tipo':
          isShow = !this.isShowTipoIssue
          this.isShowTipoIssueState(isShow)
          break
        default:
          break
      }
      this.$forceUpdate()
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('issues.filters.buyer.value'), value: 'comprador', show: this.isShowCompradorIssue
        }, {
          text: this.$t('issues.filters.seller.value'), value: 'vendedor', show: this.isShowVendedorIssue
        }, {
          text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroIssue
        }, {
          text: this.$t('invoices.invoices_entity_table.status'), value: 'estado', show: this.isShowEstadoIssue
        }, {
          text: this.$t('invoices.invoices_entity_table.project'), value: 'servicio', show: this.isShowServicioIssue
        }, {
          text: this.$t('issues.filters.subject.value'), value: 'asunto', show: this.isShowAsuntoIssue
        }, {
          text: this.$t('issues.filters.priority.value'), value: 'prioridad', show: this.isShowPrioridadIssue
        }, {
          text: this.$t('issues.filters.issue_type.value'), value: 'tipo', show: this.isShowTipoIssue
        }
      ]
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'servicio') {
            console.log('quitamos servicio')
            this.columns.splice(index, 1)
          }
          console.log('columnas: ', this.columns)
        }
        this.isShowServicioIssueState(false)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>

</style>
